export default __webpack_public_path__ + "media/images/icons/id-card-solid-77e353f61462f75b2a225e5070afda11.svg";